<div class="palantir-radio-container">
  <div class="palantir-radio"></div>
</div>
@if (label) {
  <palantir-text type="text">{{ label }}</palantir-text>
}
